// custom typefaces
import "typeface-gothic-a1"
import "./src/styles/site.css"
